(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }
      hide() {
        super.hide();
        window.pauseAllMedia();
      }
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }
      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-footer-totop]');
    if (!trigger) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;
          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom,
          };
        }
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }
    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  // Langugae Switcher
  // class LocalizationForm extends HTMLElement {
  //   constructor() {
  //     super();
  //     this.elements = {
  //       input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
  //       button: this.querySelector('button'),
  //       panel: this.querySelector('ul'),
  //     };
  //     this.elements.button.addEventListener('click', this.openSelector.bind(this));
  //     this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
  //     this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  //     this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  //   }
  //   hidePanel() {
  //     this.elements.button.setAttribute('aria-expanded', 'false');
  //     this.elements.panel.setAttribute('hidden', true);
  //   }
  //   onContainerKeyUp(event) {
  //     if (event.code.toUpperCase() !== 'ESCAPE') return;
  //     this.hidePanel();
  //     this.elements.button.focus();
  //   }
  //   onItemClick(event) {
  //     event.preventDefault();
  //     const form = this.querySelector('form');
  //     this.elements.input.value = event.currentTarget.dataset.value;
  //     if (form) form.submit();
  //   }
  //   openSelector() {
  //     this.elements.button.focus();
  //     this.elements.panel.toggleAttribute('hidden');
  //     this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  //   }
  //   closeSelector(event) {
  //     const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
  //     if (event.relatedTarget === null || shouldClose) {
  //       this.hidePanel();
  //     }
  //   }
  // }
  // customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["konfigurator-template"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }
        hide() {
          super.hide();
          window.pauseAllMedia();
        }
        show(opener) {
          super.show(opener);
          this.showActiveMedia();
        }
        showActiveMedia() {
          this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
          ).forEach((element) => {
            element.classList.remove('active');
          });
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();
          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          )
            activeMedia.loadContent();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-discounted"]) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }
      hide() {
        super.hide();
        window.pauseAllMedia();
      }
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }
      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }
        hide() {
          super.hide();
          window.pauseAllMedia();
        }
        show(opener) {
          super.show(opener);
          this.showActiveMedia();
        }
        showActiveMedia() {
          this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
          ).forEach((element) => {
            element.classList.remove('active');
          });
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();
          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          )
            activeMedia.loadContent();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp_salesection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-kb-gallery')) {
    customElements.define(
      'pdp-kb-gallery',
      class PdpKbGallery extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.thumbWrap = this.querySelector('[data-thumbs]');
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          this.index = 0;
          this.initLightbox();
          if (!this.track) return;

          this.prev && this.prev.addEventListener('click', () => this.goTo(this.index - 1));
          this.next && this.next.addEventListener('click', () => this.goTo(this.index + 1));
          this.thumbWrap && this.thumbWrap.addEventListener('click', (e) => {
            const t = e.target.closest('[data-thumb]');
            const i = t ? this.thumbs.indexOf(t) : -1;
            if (i > -1) this.goTo(i);
          });

          let raf;
          this.track.addEventListener('scroll', () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => this.syncFromScroll());
          }, { passive: true });

          this.refresh();
          this.initRoomvo();
        }
        refresh() {
          this.slides = Array.from(this.querySelectorAll('[data-slide]')).filter((s) => !s.hidden);
          this.thumbs = Array.from(this.querySelectorAll('[data-thumb]')).filter((t) => !t.hidden);
          const multi = this.slides.length > 1;
          [this.prev, this.next].forEach((b) => { if (b) b.hidden = !multi; });
          if (this.thumbWrap) this.thumbWrap.hidden = !multi;
          this.index = Math.max(0, Math.min(this.index, this.slides.length - 1));
          this.update();
        }
        initRoomvo() {
          const slide = this.querySelector('[data-roomvo-slide]');
          const wrap = this.querySelector('[data-roomvo-trigger]');
          if (!slide || !wrap) return;
          const tile = slide.querySelector('[data-roomvo-open]');
          const thumb = this.querySelector('[data-roomvo-thumb]');
          const trigger = () => wrap.querySelector('.roomvo-stimr');
          if (tile) tile.addEventListener('click', () => { const t = trigger(); if (t) t.click(); });
          const ready = () => { const t = trigger(); return !!t && getComputedStyle(t).visibility !== 'hidden'; };
          let done = false;
          const show = () => {
            if (done) return;
            done = true;
            slide.hidden = false;
            if (thumb) thumb.hidden = false;
            this.refresh();
          };
          if (ready()) { show(); return; }
          const stop = () => { obs.disconnect(); clearInterval(timer); };
          const check = () => { if (ready()) { stop(); show(); } };
          const obs = new MutationObserver(check);
          obs.observe(wrap, { attributes: true, childList: true, subtree: true });
          const timer = setInterval(check, 500);
          setTimeout(stop, 20000);
        }
        initLightbox() {
          const dlg = this.querySelector('[data-lightbox]');
          if (!dlg) return;
          let data = [];
          try { data = JSON.parse(dlg.querySelector('[data-lb-data]').textContent); } catch (e) { return; }
          const img = dlg.querySelector('[data-lb-img]');
          const stage = dlg.querySelector('[data-lb-stage]');
          const count = dlg.querySelector('[data-lb-count]');
          let cur = 0;
          let zoomed = false;
          let base = null;
          const scale = 2.5;

          const setOrigin = (x, y) => {
            const r = base || img.getBoundingClientRect();
            const ox = Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100));
            const oy = Math.min(100, Math.max(0, ((y - r.top) / r.height) * 100));
            img.style.transformOrigin = ox + '% ' + oy + '%';
          };
          const unzoom = () => {
            zoomed = false;
            base = null;
            dlg.classList.remove('is-zoomed');
            img.style.transform = '';
          };
          const show = (i) => {
            cur = (i + data.length) % data.length;
            unzoom();
            img.src = data[cur].src;
            img.alt = data[cur].alt || '';
            if (count) count.textContent = data.length > 1 ? (cur + 1) + ' / ' + data.length : '';
          };
          const open = (i) => {
            show(i);
            document.documentElement.classList.add('pdp-kb-lock');
            if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
          };
          const close = () => {
            unzoom();
            document.documentElement.classList.remove('pdp-kb-lock');
            if (dlg.open && typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
          };

          this.querySelectorAll('[data-zoom-open]').forEach((btn) => {
            btn.addEventListener('click', () => open(Number(btn.dataset.zoomOpen)));
          });
          dlg.querySelector('[data-lb-close]').addEventListener('click', close);
          const prev = dlg.querySelector('[data-lb-prev]');
          const next = dlg.querySelector('[data-lb-next]');
          prev && prev.addEventListener('click', () => show(cur - 1));
          next && next.addEventListener('click', () => show(cur + 1));
          dlg.addEventListener('close', () => { unzoom(); document.documentElement.classList.remove('pdp-kb-lock'); });
          dlg.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') show(cur - 1);
            if (e.key === 'ArrowRight') show(cur + 1);
          });

          img.addEventListener('click', (e) => {
            if (zoomed) { unzoom(); return; }
            base = img.getBoundingClientRect();
            setOrigin(e.clientX, e.clientY);
            zoomed = true;
            dlg.classList.add('is-zoomed');
            img.style.transform = 'scale(' + scale + ')';
          });
          stage.addEventListener('mousemove', (e) => { if (zoomed) setOrigin(e.clientX, e.clientY); });
          stage.addEventListener('touchmove', (e) => {
            if (zoomed && e.touches.length === 1) { e.preventDefault(); setOrigin(e.touches[0].clientX, e.touches[0].clientY); }
          }, { passive: false });
          stage.addEventListener('click', (e) => { if (e.target === stage && !zoomed) close(); });

          let sx = null;
          stage.addEventListener('touchstart', (e) => { sx = !zoomed && e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
          stage.addEventListener('touchend', (e) => {
            if (sx === null || zoomed) return;
            const dx = e.changedTouches[0].clientX - sx;
            if (Math.abs(dx) > 50) show(cur + (dx < 0 ? 1 : -1));
            sx = null;
          });
        }
        step() {
          if (this.slides.length < 2) return this.track.clientWidth;
          return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        }
        goTo(i) {
          const max = this.slides.length - 1;
          this.index = Math.max(0, Math.min(max, i));
          this.track.scrollTo({ left: this.slides[this.index].offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' });
          this.update();
        }
        syncFromScroll() {
          const i = Math.round(this.track.scrollLeft / this.step());
          if (i !== this.index) {
            this.index = Math.max(0, Math.min(this.slides.length - 1, i));
            this.update();
          }
        }
        update() {
          if (!this.slides || !this.slides.length) return;
          const cur = this.slides[this.index];
          this.classList.toggle('is-roomvo', !!cur && cur.hasAttribute('data-roomvo-slide'));
          this.thumbs.forEach((t, n) => {
            if (n === this.index) {
              t.setAttribute('aria-current', 'true');
              if (this.thumbWrap) {
                const l = t.offsetLeft - this.thumbWrap.offsetLeft;
                if (l < this.thumbWrap.scrollLeft || l + t.offsetWidth > this.thumbWrap.scrollLeft + this.thumbWrap.clientWidth) {
                  this.thumbWrap.scrollTo({ left: l - 16, behavior: 'smooth' });
                }
              }
            } else {
              t.removeAttribute('aria-current');
            }
          });
          if (this.prev) this.prev.disabled = this.index === 0;
          if (this.next) this.next.disabled = this.index === this.slides.length - 1;
        }
      }
    );
  }

  if (!customElements.get('pdp-kb-qty')) {
    customElements.define(
      'pdp-kb-qty',
      class PdpKbQty extends HTMLElement {
        connectedCallback() {
          this.per = parseFloat(String(this.dataset.m2PerPackage || '0').replace(',', '.')) || 0;
          this.m2 = this.querySelector('[data-qty-m2]');
          this.pkg = this.querySelector('[data-qty-pkg]');
          this.minus = this.querySelectorAll('[data-qty-minus]');
          this.plus = this.querySelectorAll('[data-qty-plus]');
          this.real = this.querySelector('[data-qty-real]');
          if (!this.pkg) return;

          /* Verschnitt: this.base ist die Raumfläche ohne Verschnitt */
          this.cut = this.querySelector('[data-qty-cut]');
          this.cutPct = this.cut ? parseFloat(String(this.cut.dataset.cutPct).replace(',', '.')) || 0 : 0;
          this.base = parseFloat(this.dataset.startM2) || this.currentPkg() * this.per;
          if (this.cut && this.per > 0) {
            this.cut.addEventListener('change', () => {
              this.setPkg(Math.ceil(this.base * this.factor() / this.per - 1e-9), true);
            });
          }

          const form = this.closest('form');
          if (form) {
            form.addEventListener('submit', () => this.syncReal(), true);
            form.addEventListener('click', (e) => {
              if (e.target.closest('[type="submit"]')) this.syncReal();
            }, true);
          }

          if (this.m2 && this.per > 0) {
            this.m2.addEventListener('input', () => {
              const v = this.parse(this.m2.value);
              if (v > 0) {
                this.base = v;
                this.setPkg(Math.ceil(v * this.factor() / this.per - 1e-9), false);
              }
            });
            this.m2.addEventListener('change', () => this.setPkg(this.currentPkg(), true));
          }
          this.pkg.addEventListener('input', () => {
            const n = parseInt(this.pkg.value, 10);
            if (n >= 1) {
              this.base = n * this.per / this.factor();
              this.syncM2(n);
            }
            this.updateButtons();
          });
          if (this.m2) this.m2.addEventListener('input', () => this.syncReal());
          this.pkg.addEventListener('change', () => this.setPkg(this.currentPkg(), true));
          this.minus.forEach((b) => b.addEventListener('click', () => this.stepPkg(-1)));
          this.plus.forEach((b) => b.addEventListener('click', () => this.stepPkg(1)));
          this.updateButtons();
        }
        parse(v) {
          const n = parseFloat(String(v).replace(/\s/g, '').replace(',', '.'));
          return isNaN(n) ? 0 : n;
        }
        factor() {
          return this.cut && this.cut.checked ? 1 + this.cutPct / 100 : 1;
        }
        applyArea(v) {
          if (!(v > 0) || !(this.per > 0)) return;
          this.base = v;
          this.setPkg(Math.ceil(v * this.factor() / this.per - 1e-9), true);
        }
        stepPkg(d) {
          this.base = d > 0 ? this.base + this.per : Math.max(this.per, this.base - this.per);
          this.setPkg(this.currentPkg() + d, true);
        }
        currentPkg() {
          const n = parseInt(this.pkg.value, 10);
          return isNaN(n) || n < 1 ? 1 : n;
        }
        format(n) {
          return (Math.round(n * 1000) / 1000).toLocaleString('de-DE', { maximumFractionDigits: 3 });
        }
        syncM2(n) {
          if (this.m2 && this.per > 0) this.m2.value = this.format(n * this.per);
        }
        setPkg(n, updateM2) {
          n = Math.max(1, Math.round(n));
          this.pkg.value = n;
          if (updateM2) this.syncM2(n);
          this.updateButtons();
          this.pkg.dispatchEvent(new Event('pdp-kb:qty', { bubbles: true }));
        }
        syncReal() {
          if (this.real) this.real.value = this.currentPkg();
        }
        updateButtons() {
          this.minus.forEach((b) => { b.disabled = this.currentPkg() <= 1; });
          this.syncReal();
        }
      }
    );
  }

  /* Angebot anfragen: HubSpot-Formular-Link mit Produkt, Paketanzahl, EAN und m² vorbelegen.
     Gleiche Feldnamen wie im Warenkorb-Script (assets/cart-drawer.js).
     Bei Produkten mit m²-Angabe erscheint der Knopf erst oberhalb der eingestellten Fläche. */
  (function () {
    const init = (root) => {
      root.querySelectorAll('.pdp-kb [data-quote-btn]').forEach((btn) => {
        if (btn.dataset.quoteInit) return;
        btn.dataset.quoteInit = '1';
        const section = btn.closest('.pdp-kb');

        const build = () => {
          const form = section.querySelector('form[data-type="add-to-cart-form"]');
          const idInput = form ? form.querySelector('input[name="id"]') : null;
          const variantId = idInput ? idInput.value : '';
          const pkgEl = section.querySelector('[data-qty-pkg]');
          const m2El = section.querySelector('[data-qty-m2]');
          const pkgs = Math.max(1, parseInt(pkgEl ? pkgEl.value : '1', 10) || 1);
          const m2 = m2El ? parseFloat(String(m2El.value).replace(/\s/g, '').replace(',', '.')) || 0 : 0;
          const barcode = (window.pdpBarcodeMap && window.pdpBarcodeMap[variantId]) || '';
          const title = btn.dataset.productTitle || 'Produkt';

          if (btn.dataset.quoteGated === 'true') {
            const qtyEl = section.querySelector('pdp-kb-qty');
            const per = parseFloat(String(qtyEl ? qtyEl.dataset.m2PerPackage : '0').replace(',', '.')) || 0;
            const min = parseFloat(btn.dataset.quoteMinM2) || 50;
            btn.hidden = !(pkgs * per > min + 1e-9);
          }

          const base = btn.dataset.b2b === 'true' ? btn.dataset.formB2b : btn.dataset.formB2c;
          if (!base) return;

          const params = new URLSearchParams();
          params.append('0-1/message', pkgs + ' x ' + title + (barcode ? ' (' + barcode + ')' : ''));
          if (m2 > 0) params.append('0-1/benotigte_quadratmeter_', String(Math.round(m2 * 1000) / 1000));
          params.append('0-1/quelle__verstecktes_feld_', btn.dataset.quoteSource || 'Produktseite');
          btn.setAttribute('href', base + '?' + params.toString());
        };

        build();
        section.addEventListener('input', build);
        section.addEventListener('change', build);
        section.addEventListener('pdp-kb:qty', build);
        section.addEventListener('click', (e) => {
          if (e.target.closest('[data-qty-minus], [data-qty-plus]')) setTimeout(build, 0);
        });
        btn.addEventListener('click', build);
        btn.addEventListener('auxclick', build);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  if (!customElements.get('pdp-kb-video')) {
    customElements.define(
      'pdp-kb-video',
      class PdpKbVideo extends HTMLElement {
        connectedCallback() {
          const btn = this.querySelector('[data-play]');
          const tpl = this.querySelector('template');
          if (!btn || !tpl) return;
          btn.addEventListener('click', () => {
            this.appendChild(tpl.content.cloneNode(true));
            btn.remove();
            const v = this.querySelector('video');
            if (v) v.play().catch(() => {});
          }, { once: true });
        }
      }
    );
  }

  (function () {
    const init = (root) => {
      root.querySelectorAll('.pdp-kb [data-desc]').forEach((body) => {
        const content = body.querySelector('[data-desc-content]');
        const more = body.querySelector('[data-desc-more]');
        if (!content || !more) return;
        const lessLabel = 'Weniger anzeigen';
        const moreLabel = more.textContent.trim();
        const check = () => {
          if (body.classList.contains('is-expanded')) return;
          const clipped = content.scrollHeight > content.clientHeight + 2;
          more.hidden = !clipped;
          body.classList.toggle('no-clip', !clipped);
        };
        more.addEventListener('click', () => {
          const open = body.classList.toggle('is-expanded');
          more.textContent = open ? lessLabel : moreLabel;
          more.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        check();
        window.addEventListener('resize', check, { passive: true });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  /* Sticky-Leiste (Snippet product-sticky-atc) mit der Mengenauswahl verbinden.
     Übergangslösung: Das Snippet bleibt unverändert, weil die alte Produktseite es weiter nutzt.
     Die Sektion rechnet Pakete und Verschnitt, die Leiste zeigt nur an und leitet Eingaben weiter. */
  (function () {
    const eur = (n) => n.toFixed(2).replace('.', ',') + '€';
    const num = (el, attr) => (el ? parseFloat(String(el.getAttribute(attr) || '').replace(',', '.')) || 0 : 0);
    const qtyEl = () => document.querySelector('.pdp-kb pdp-kb-qty');
    let fromSticky = false;

    const render = (keepInput) => {
      const qty = qtyEl();
      const bar = document.querySelector('.product-sticky-atc-main');
      if (!qty || !qty.pkg || !bar) return;
      const pkg = qty.currentPkg();

      bar.querySelectorAll('.Pakete_dynamic').forEach((el) => { el.textContent = pkg; });
      const priceEl = bar.querySelector('.product-sticky-atc-price');
      const orig = bar.querySelector('.product-sticky-atc-original');
      if (orig) orig.textContent = eur(num(priceEl, 'base-price-val') * pkg);
      const cmp = bar.querySelector('.product-sticky-atc-compare');
      if (cmp) cmp.textContent = eur(num(cmp, 'base-compare-val') * pkg);
      const save = bar.querySelector('.product-sticky-atc-save-child');
      if (save) save.textContent = eur(num(save, 'base-saving-val') * pkg);

      const input = bar.querySelector('.stikcy_qty_input');
      if (input && !keepInput && qty.per > 0) {
        input.step = 'any';
        input.value = Math.round(pkg * qty.per * 100) / 100;
      }
      const real = bar.querySelector('.real_qty_input');
      if (real) real.value = pkg;
    };
    /* Verzögert, damit die eigenen Handler der Leiste vorher laufen und wir ihre Werte überschreiben */
    const later = (keepInput) => setTimeout(() => render(keepInput), 0);

    /* Sektion -> Leiste: jede Mengenänderung (Felder, Plus/Minus, Verschnitt) */
    document.addEventListener('pdp-kb:qty', () => later(fromSticky));

    /* Leiste -> Sektion: Tippen im m²-Feld der Leiste */
    document.addEventListener('input', (e) => {
      if (!e.isTrusted || !e.target.matches('.stikcy_qty_input')) return;
      const qty = qtyEl();
      if (!qty) return;
      const v = parseFloat(String(e.target.value).replace(',', '.'));
      if (!(v > 0)) return;
      fromSticky = true;
      qty.applyArea(v);
      fromSticky = false;
    });

    /* Leiste schreibt beim Verlassen ganze m² in unser Feld: Anzeige wiederherstellen */
    document.addEventListener('change', (e) => {
      if (!e.target.matches('.stikcy_qty_input')) return;
      const qty = qtyEl();
      if (!qty || !qty.pkg) return;
      setTimeout(() => { qty.syncM2(qty.currentPkg()); render(false); }, 0);
    });

    /* Plus/Minus der Leiste: ein Paket statt 1 m², wie in der Sektion */
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.stikcy_qty_plus, .stikcy_qty_minus');
      if (!btn) return;
      const qty = qtyEl();
      if (!qty || !qty.pkg) return;
      qty.stepPkg(btn.classList.contains('stikcy_qty_plus') ? 1 : -1);
    });

    /* Erst nach window.load: Die Leiste liest beim Laden ihre Grundpreise aus dem Text */
    if (document.readyState === 'complete') later(false);
    else window.addEventListener('load', () => later(false));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
